import {Component, Inject, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import * as _ from 'lodash';
import {interval, Subscription} from 'rxjs';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';

@AcDialog({
  title: 'Information',
  width: 450,
  height: 120
})
@Component({
  selector: 'certificate-reload-dialog',
  templateUrl: './certificate-reload-dialog.component.html',
  styleUrls: ['./certificate-reload-dialog.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class CertificateReloadDialogComponent implements OnInit, OnDestroy {

  message = '';
  onCloseCallback;
  progressBarValue;
  countdownInSeconds;
  subscription: Subscription;
  action;

  constructor(@Inject(DIALOG_CONFIG) public dialogConfig) {
    this.countdownInSeconds = dialogConfig.dialogData.countdownInSeconds;
    this.message = dialogConfig.dialogData.message;
    this.action = dialogConfig.dialogData.action;
    this.onCloseCallback = dialogConfig.dialogData.onCloseCallback;
  }

  ngOnInit(): void {
      this.progressBarValue = 0;

      const source = interval(1000);
      this.subscription = source.subscribe(() => this.progressBarValue += (100 / this.countdownInSeconds));

      setTimeout(() => {
        this.action();
      }, this.countdownInSeconds * 1000);
  }

  onClose(): void {
    if (!_.isNil(this.onCloseCallback)) {
      this.onCloseCallback();
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
